/* eslint-disable import/prefer-default-export */
export const SCORE_LIMITS = {
  upperLimit: 50,
  lowerLimit: -50,
};
